import { makeVar } from '@apollo/client';

export const isBankAccountEditModeVar = makeVar(true);
